import { render, staticRenderFns } from "./canReceive.vue?vue&type=template&id=0afb3917&scoped=true"
import script from "./canReceive.vue?vue&type=script&lang=js"
export * from "./canReceive.vue?vue&type=script&lang=js"
import style0 from "./canReceive.vue?vue&type=style&index=0&id=0afb3917&prod&lang=css"
import style1 from "./canReceive.vue?vue&type=style&index=1&id=0afb3917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb3917",
  null
  
)

export default component.exports